<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useUserStore } from '@/stores/userStore'
import SideBarItem from './SideBarItem.vue'
import { useBreakpoints } from '@/utils/useBreakpoints'

const { t } = useI18n()
const authStore = useAuthStore()
const userStore = useUserStore()

const userRole = computed(() => userStore.roles?.[0] || '')
const canAccessAdminPages = computed(() => ['Projektadmin'].includes(userRole.value))
const isMobile = useBreakpoints().smaller('md')
</script>

<template>
  <!-- Entry List -->
  <SideBarItem
    v-if="authStore.isLoggedIn && userStore.firma"
    to="entries-list"
    :other-active-routes="isMobile ? ['entry'] : undefined"
    :title="t('nav.labels.entriesList')"
  >
    <template #icon>
      <Icon icon="fa:table-list-solid" class="text-2xl md:text-3xl lg:text-2xl" />
    </template>
  </SideBarItem>

  <!-- Entry -->
  <SideBarItem
    v-if="authStore.isLoggedIn && userStore.firma && !isMobile"
    to="entry"
    path="/entry/:id?"
    :title="t('nav.labels.entry')"
  >
    <template #icon>
      <Icon icon="fa:folder-open-solid-full" class="text-2xl md:text-3xl lg:text-2xl" />
    </template>
  </SideBarItem>

  <!-- Designer -->
  <SideBarItem
    v-if="authStore.isLoggedIn && userStore.firma && canAccessAdminPages && !isMobile"
    to="designer"
    :title="t('nav.labels.designer')"
  >
    <template #icon>
      <Icon icon="fa:pen-nib-solid-full" class="text-2xl md:text-3xl lg:text-2xl" />
    </template>
  </SideBarItem>

  <!-- User Management -->
  <SideBarItem
    v-if="authStore.isLoggedIn && userStore.firma && canAccessAdminPages"
    to="user-management"
    :title="t('nav.labels.userManagement')"
  >
    <template #icon>
      <Icon icon="fa:users-solid" class="text-2xl md:text-3xl lg:text-2xl" />
    </template>
  </SideBarItem>
</template>
